const BreadcrumbsLinks = {
  '/mypage/login': ['/', '/mypage/login'],
  '/mypage/history': ['/', '/mypage/history'],
  '/about/payment': ['/', '/about/payment'],
  '/about/delivery': ['/', '/about/delivery'],
  '/about/gift': ['/', '/about/gift'],
  '/terms': ['/', '/terms'],
  '/faq': ['/', '/faq'],
  '/specified': ['/', '/specified'],
  '/contact': ['/', '/contact']
};

export default BreadcrumbsLinks;



// WEBPACK FOOTER //
// ./src/constants/breadcrumbs-links.js